import React, { useState } from "react";
import Tooltip from "../../../Common/Tooltip";
import {
  OIB,
  PIN,
  email,
  lettersOnly,
  numbersOnly,
} from "../../../../Config/Regex";
import { useTranslation } from "react-i18next";
import { validationService } from "../../../../Services/validation.service";
import Stepper from "../../components/Stepper";
import { useForm } from "react-hook-form";
import { FORM_FIELDS } from "../../Constants";
import ErrorMessage from "../../components/ErrorMessage";

const UserData = ({ stepState, previousPage, nextPage, formData }) => {
  const { t: translator } = useTranslation();
  const { USER_DATA } = FORM_FIELDS;

  const [, setRerender] = useState(false);

  const { register, handleSubmit, errors, getValues } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: formData[USER_DATA.name],
  });

  const onNextPage = (data) => {
    nextPage({ [USER_DATA.name]: data });
  };

  const ADDITIONAL_OIB = getValues(USER_DATA.ADDITIONAL_OIB.name);
  console.log("ADDITIONAL ", ADDITIONAL_OIB);
  return (
    <>
      <div className="row">
        <div className="col-lg-6">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">Podaci o vlasniku</legend>
            <div className="form-container">
              <div className="form-group">
                <label htmlFor="taxNumber">
                  {USER_DATA.OIB.title}
                  <b>*</b>
                </label>
                <Tooltip text="Unesite 11-znamenkasti OIB vlasnika." />
                <input
                  className="form-control"
                  type="text"
                  name={USER_DATA.OIB.name}
                  ref={register({
                    required: true,
                    pattern: OIB,
                    validate: (data) => {
                      if (
                        data ===
                        document.getElementsByName(
                          USER_DATA.ADDITIONAL_OIB.name
                        )[0]?.value
                      ) {
                        return false;
                      }
                      return validationService.validateUserOib(
                        document.getElementsByName(USER_DATA.OIB.name)[0].value
                      );
                    },
                  })}
                />

                <ErrorMessage
                  errorType={errors?.[USER_DATA.OIB.name]?.type}
                  messages={{
                    required: "Ovo polje je obavezno!",
                    validate: "OIB nije važeći ili je već u upotrebi!",
                    pattern: "OIB mora sadržavati točno 11 znamenki!",
                  }}
                />
              </div>

              <div className="row">
                <div className="form-group col-lg-6 m-0">
                  <label htmlFor="realName">
                    {USER_DATA.FIRST_NAME.title}
                    <b>*</b>
                  </label>{" "}
                  <Tooltip text={translator("Ime vlasnika")} />
                  <input
                    type="text"
                    className="form-control"
                    name={USER_DATA.FIRST_NAME.name}
                    ref={register({
                      required: true,
                      maxLength: 50,
                      pattern: lettersOnly,
                    })}
                  />
                  <ErrorMessage
                    errorType={errors?.[USER_DATA.FIRST_NAME.name]?.type}
                    messages={{
                      required: "Ovo polje je obavezno!",
                      maxLength: "Moguće je unijeti maksimalno 50 znakova!",
                      pattern: "Dopušten je samo tekstualni unos!",
                    }}
                  />
                </div>
                <div className="form-group col-lg-6 m-0">
                  <label htmlFor="realName">
                    {USER_DATA.LAST_NAME.title}
                    <b>*</b>
                  </label>{" "}
                  <Tooltip text={translator("Prezime vlasnika")} />
                  <input
                    type="text"
                    className="form-control"
                    name={USER_DATA.LAST_NAME.name}
                    ref={register({
                      required: true,
                      maxLength: 50,
                      pattern: lettersOnly,
                    })}
                  />
                  <ErrorMessage
                    errorType={errors?.[USER_DATA.LAST_NAME.name]?.type}
                    messages={{
                      required: "Ovo polje je obavezno!",
                      maxLength: "Moguće je unijeti maksimalno 50 znakova!",
                      pattern: "Dopušten je samo tekstualni unos!",
                    }}
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor={USER_DATA.PHONE.name}>
                  {USER_DATA.PHONE.title}
                </label>{" "}
                <Tooltip text={translator("Broj telefona")} />
                <input
                  type="text"
                  className="form-control"
                  name={USER_DATA.PHONE.name}
                  ref={register({
                    // required: true,
                    pattern: numbersOnly,
                    maxLength: 20,
                  })}
                />
                <ErrorMessage
                  errorType={errors?.[USER_DATA.PHONE.name]?.type}
                  messages={{
                    required: "Ovo polje je obavezno!",
                    pattern: "Molimo unesite samo brojeve!!",
                    maxLength: "Moguće je unijeti maksimalno 20 znakova!",
                  }}
                />
              </div>

              <div className="form-group">
                <label htmlFor={USER_DATA.EMAIL.name}>
                  {USER_DATA.EMAIL.title}
                  <b>*</b>
                </label>{" "}
                <Tooltip
                  text={
                    "Važeća email adresa vlasnika tvrtke ili obrta na koju će biti poslana privremena lozinka za pristup softveru za fiskalnu blagajnu."
                  }
                />
                <input
                  type="text"
                  className="form-control"
                  name={USER_DATA.EMAIL.name}
                  ref={register({
                    required: true,
                    pattern: email,
                    maxLength: 50,
                  })}
                />
                <ErrorMessage
                  errorType={errors?.[USER_DATA.EMAIL.name]?.type}
                  messages={{
                    required: "Ovo polje je obavezno!",
                    pattern: "Molimo unesite validan email!",
                    maxLength: "Moguće je unijeti maksimalno 50 znakova!",
                  }}
                />
              </div>

              <div className="form-group p-relative">
                <label htmlFor={USER_DATA.PIN.name}>
                  {USER_DATA.PIN.title} <b>*</b>
                </label>{" "}
                <Tooltip
                  text={
                    "Jedinstveni pin sa kojim će se vlasnik prijavljivati na blagajnu."
                  }
                />
                <input
                  type={"text"}
                  className="form-control"
                  name={USER_DATA.PIN.name}
                  ref={register({
                    required: true,
                    pattern: PIN,
                    validate: (data) => {
                      if (
                        document.getElementsByName(
                          USER_DATA.ADDITIONAL_PIN.name
                        )[0].value === data
                      ) {
                        return false;
                      }
                      return true;
                    },
                  })}
                />
                <ErrorMessage
                  errorType={errors?.[USER_DATA.PIN.name]?.type}
                  messages={{
                    required: "Ovo polje je obavezno!",
                    pattern: "PIN mora imati četiri (4) znamenke.",
                    validate: "PIN mora biti različit.",
                  }}
                />
              </div>
            </div>
          </fieldset>
        </div>
        <div className="col-lg-6">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              Podaci o dodatnom blagajniku
              <Tooltip
                text={
                  "Ukoliko imate potrebu dodati dodatnog blagajnika popunite sljedeće podatke."
                }
              />
            </legend>
            <div className="form-container">
              <div className="form-group">
                <p>
                  ** Ukoliko unesete oib dodatnog blagjanika, morate popuniti i
                  preostala polja.
                </p>
              </div>
              <div className="form-group">
                <label htmlFor="taxNumber">
                  {USER_DATA.ADDITIONAL_OIB.title} <b>**</b>
                </label>
                <Tooltip text="Unesite 11-znamenkasti OIB dodatnog blagajnika. Ne može biti isti kao oib vlasnika." />
                <input
                  className="form-control"
                  type="text"
                  name={USER_DATA.ADDITIONAL_OIB.name}
                  onBlur={() => {
                    console.log("MY COMPONENT IS BLURED");
                    setRerender((x) => !x);
                  }}
                  ref={register({
                    required: false,
                    pattern: OIB,
                    validate: () =>
                      validationService.validateUserOib(
                        document.getElementsByName(
                          USER_DATA.ADDITIONAL_OIB.name
                        )[0].value
                      ),
                  })}
                />

                <ErrorMessage
                  errorType={errors?.[USER_DATA.ADDITIONAL_OIB.name]?.type}
                  messages={{
                    required: "Ovo polje je obavezno!",
                    validate: "OIB nije važeći ili je već u upotrebi!",
                    pattern: "OIB mora sadržavati točno 11 znamenki!",
                  }}
                />
              </div>

              <div className="row">
                <div className="form-group col-lg-6 m-0">
                  <label htmlFor="realName">
                    {USER_DATA.ADDITIONAL_FIRST_NAME.title}
                  </label>{" "}
                  <Tooltip text={"Ime dodatnog blagajnika"} />
                  <input
                    type="text"
                    className="form-control"
                    name={USER_DATA.ADDITIONAL_FIRST_NAME.name}
                    disabled={!ADDITIONAL_OIB}
                    ref={register({
                      required: !!ADDITIONAL_OIB,
                      maxLength: 50,
                      pattern: lettersOnly,
                    })}
                  />
                  <ErrorMessage
                    errorType={
                      errors?.[USER_DATA.ADDITIONAL_FIRST_NAME.name]?.type
                    }
                    messages={{
                      required: "Ovo polje je obavezno!",
                      maxLength: "Moguće je unijeti maksimalno 50 znakova!",
                      pattern: "Dopušten je samo tekstualni unos!",
                    }}
                  />
                </div>

                <div className="form-group col-lg-6 m-0">
                  <label htmlFor="realName">
                    {USER_DATA.ADDITIONAL_LAST_NAME.title}
                  </label>{" "}
                  <Tooltip text={"Prezime dodatnog blagajnika"} />
                  <input
                    type="text"
                    className="form-control"
                    disabled={!ADDITIONAL_OIB}
                    name={USER_DATA.ADDITIONAL_LAST_NAME.name}
                    ref={register({
                      required: !!ADDITIONAL_OIB,
                      maxLength: 50,
                      pattern: lettersOnly,
                    })}
                  />
                  <ErrorMessage
                    errorType={
                      errors?.[USER_DATA.ADDITIONAL_LAST_NAME.name]?.type
                    }
                    messages={{
                      required: "Ovo polje je obavezno!",
                      maxLength: "Moguće je unijeti maksimalno 50 znakova!",
                      pattern: "Dopušten je samo tekstualni unos!",
                    }}
                  />
                </div>
              </div>

              <div className="form-group p-relative">
                <label htmlFor={USER_DATA.ADDITIONAL_PIN.name}>
                  {USER_DATA.ADDITIONAL_PIN.title}
                </label>{" "}
                <Tooltip
                  text={
                    "Jedinstveni pin sa kojim će se blagajnik prijavljivati na blagajnu. Ne može biti isti kao pin vlasnika."
                  }
                />
                <input
                  type={"text"}
                  className="form-control"
                  name={USER_DATA.ADDITIONAL_PIN.name}
                  disabled={!ADDITIONAL_OIB}
                  ref={register({
                    required: !!ADDITIONAL_OIB,
                    pattern: PIN,
                    validate: (data) => {
                      if (
                        document.getElementsByName(USER_DATA.PIN.name)[0]
                          .value === data
                      ) {
                        return false;
                      }
                      return true;
                    },
                  })}
                />
                <ErrorMessage
                  errorType={errors?.[USER_DATA.ADDITIONAL_PIN.name]?.type}
                  messages={{
                    required: "Ovo polje je obavezno!",
                    pattern: "PIN mora imati četiri (4) znamenke.",
                    validate: "PIN mora biti različit.",
                  }}
                />
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      <Stepper
        stepState={stepState}
        previousPage={previousPage}
        nextPage={handleSubmit(onNextPage)}
      />
    </>
  );
};

export default UserData;
